/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupAndRound
 */
export interface UserGroupAndRound {
    /**
     * 
     * @type {string}
     * @memberof UserGroupAndRound
     */
    userGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAndRound
     */
    tournamentRoundId: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAndRound
     */
    userGroupName: string;
    /**
     * 
     * @type {number}
     * @memberof UserGroupAndRound
     */
    rank: number;
    /**
     * 
     * @type {number}
     * @memberof UserGroupAndRound
     */
    totalNumberOfGroups: number;
}

/**
 * Check if a given object implements the UserGroupAndRound interface.
 */
export function instanceOfUserGroupAndRound(value: object): value is UserGroupAndRound {
    if (!('userGroupId' in value) || value['userGroupId'] === undefined) return false;
    if (!('tournamentRoundId' in value) || value['tournamentRoundId'] === undefined) return false;
    if (!('userGroupName' in value) || value['userGroupName'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('totalNumberOfGroups' in value) || value['totalNumberOfGroups'] === undefined) return false;
    return true;
}

export function UserGroupAndRoundFromJSON(json: any): UserGroupAndRound {
    return UserGroupAndRoundFromJSONTyped(json, false);
}

export function UserGroupAndRoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAndRound {
    if (json == null) {
        return json;
    }
    return {
        
        'userGroupId': json['userGroupId'],
        'tournamentRoundId': json['tournamentRoundId'],
        'userGroupName': json['userGroupName'],
        'rank': json['rank'],
        'totalNumberOfGroups': json['totalNumberOfGroups'],
    };
}

export function UserGroupAndRoundToJSON(value?: UserGroupAndRound | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userGroupId': value['userGroupId'],
        'tournamentRoundId': value['tournamentRoundId'],
        'userGroupName': value['userGroupName'],
        'rank': value['rank'],
        'totalNumberOfGroups': value['totalNumberOfGroups'],
    };
}

